export const QueryKeyEnum = {
  ANALYSIS_REMARKS: {
    COMMENTS: {
      ALL: 'ANALYSIS_REMARKS_COMMENTS_ALL',
      CREATE: 'ANALYSIS_REMARKS_COMMENTS_CREATE',
    },
    CREATE: 'ANALYSIS_REMARKS_CREATE',
    DETAILS: 'ANALYSIS_REMARKS_DETAILS',
    SEARCH: 'ANALYSIS_REMARKS_SEARCH',
    STATE_UPDATE: 'ANALYSIS_REMARKS_STATE_UPDATE',
  },
  CANDIDATE_CV_DOWNLOAD: 'CANDIDATE_CV_DOWNLOAD',
  CANDIDATE_DETAILS: 'CANDIDATE_DETAILS',
  CANDIDATE_STATUS: 'CANDIDATE_STATUS',
  CANDIDATES_ADDITIONAL_OPTIONS: 'CANDIDATES_ADDITIONAL_OPTIONS',
  CREATE_INTERVIEW_SIMULATIONS: 'CREATE_INTERVIEW_SIMULATIONS',
  CURRENT_USER_DETAILS: 'CURRENT_USER_DETAILS',
  ENV: 'ENV',
  EXPERIENCE_COMPANIES: {
    ALL: 'EXPERIENCE_COMPANIES',
    CREATE: 'EXPERIENCE_COMPANIES_CREATE',
    DELETE: 'EXPERIENCE_COMPANIES_DELETE',
    UPDATE: 'EXPERIENCE_COMPANIES_UPDATE',
  },
  EXPERIENCE_COMPANY_GROUPS: {
    ALL: 'EXPERIENCE_COMPANY_GROUPS',
  },
  GET_PROCESS_STATUS: 'GET_PROCESS_STATUS',
  INTERVIEW_SIMULATIONS: 'INTERVIEW_SIMULATIONS',
  INTERVIEW_SIMULATIONS_DETAILS: 'INTERVIEW_SIMULATIONS_DETAILS',
  INTERVIEW_SIMULATIONS_STATUS: 'INTERVIEW_SIMULATIONS_STATUS',
  MEETINGS: {
    DELIVERIES: 'MEETINGS_DELIVERIES',
    DETAILS: 'MEETINGS_DETAILS',
    DOCUMENT_PDF: 'MEETINGS_DOCUMENT_PDF',
    EVENTS: 'MEETINGS_EVENTS',
    FEEDBACKS: 'MEETINGS_FEEDBACKS',
    NOTE: 'MEETINGS_NOTE',
    NOTE_PARTS: 'MEETINGS_NOTE_PARTS',
    NOTE_PARTS_PREVIEW: 'MEETINGS_NOTE_PARTS_PREVIEW',
    NOTE_PDF: 'MEETINGS_NOTE_PDF',
    ORGANIZERS: 'MEETINGS_ORGANIZERS',
    SAVE_FEEDBACK: 'MEETINGS_SAVE_FEEDBACK',
    SEARCH: 'MEETINGS_SEARCH',
    SEND_NOTE: 'MEETINGS_SEND_NOTE',
    TRANSCRIPT: 'MEETINGS_TRANSCRIPT',
    UPDATE_NOTE: 'MEETINGS_UPDATE_NOTE',
  },
  PROCESS: {
    CV_UPLOAD: 'PROCESS_CV_UPLOAD',
    DETAILS: 'PROCESS_DETAILS',
    POSSIBLE_STATUSES: 'PROCESS_POSSIBLE_STATUSES',
    SET_ANALYSIS_MODE: 'PROCESS_SET_ANALYSIS_MODE',
    SET_CLOSED: 'PROCESS_SET_HIDDEN',
    SET_DEFINED: 'PROCESS_SET_DEFINED',
    START: 'PROCESS_START',
  },
  PROCESS_CANDIDATES: {
    ALL: 'PROCESS_CANDIDATES_ALL',
    DELETE: 'PROCESS_CANDIDATES_DELETE',
    STATISTICS: 'PROCESS_CANDIDATES_STATISTICS',
  },
  PROCESS_TEMPLATES: {
    ALL: 'PROCESS_TEMPLATES',
    CREATE: 'PROCESS_TEMPLATES_CREATE',
    DELETE: 'PROCESS_TEMPLATES_DELETE',
    UPDATE: 'PROCESS_TEMPLATES_UPDATE',
  },
  PROCESSES: {
    ALL: 'PROCESSES_ALL',
    STATUS_COUNT: 'PROCESSES_STATUS_COUNT',
  },
  USERS: {
    ALL: 'USERS',
    SAVE_TOURS: 'SAVE_TOURS',
    SKIPPED: 'USERS_SKIPPED',
    TOURS: 'USER_TOURS',
  },
} as const;
